import { render, staticRenderFns } from "./fieldSetting.vue?vue&type=template&id=a3af97ec&scoped=true"
import script from "./fieldSetting.vue?vue&type=script&lang=js"
export * from "./fieldSetting.vue?vue&type=script&lang=js"
import style0 from "./fieldSetting.vue?vue&type=style&index=0&id=a3af97ec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3af97ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3af97ec')) {
      api.createRecord('a3af97ec', component.options)
    } else {
      api.reload('a3af97ec', component.options)
    }
    module.hot.accept("./fieldSetting.vue?vue&type=template&id=a3af97ec&scoped=true", function () {
      api.rerender('a3af97ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/crud/components/fieldSetting.vue"
export default component.exports